import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-informasi-distributor',
  template: `<app-tab-informasi-distributor />`,
})
export class InformasiDistributorComponent implements OnInit {
  snapshotParams!: Params;
  constructor(private activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {
    this.snapshotParams = this.activatedRoute.snapshot.params;
  }
}
